import {getConfigItem, configConstants} from '@servicenow/ui-config';
import {INTERSECTION_TRIGGERED} from '../symbols';
const {INTERSECT_ROOT_MARGIN} = configConstants;
function intersection(entries) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target[INTERSECTION_TRIGGERED]();
			observer.unobserve(entry.target);
		}
	});
}

// The distance away from the viewport when a component should render
const VIEWPORT_INTERSECTION_MARGIN = getConfigItem(INTERSECT_ROOT_MARGIN);
const options = {rootMargin: VIEWPORT_INTERSECTION_MARGIN};

let observer;
if (!window.IntersectionObserver) observer = {observe() {}, unobserve() {}};
else observer = new IntersectionObserver(intersection, options);

export default observer;
